import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BASE = `${API}/admin/invite`;

export const inviteApi = {
  dashboard: (exhibitionId, opts = {}) =>
    axios.get(`${BASE}/dashboard`, {
      params: { exhibition_id: exhibitionId, days: opts.days || 30, ...(opts.category ? { category: opts.category } : {}) },
    }).then((r) => r.data),

  // Searches
  createSearch: (payload) => axios.post(`${BASE}/search`, payload).then((r) => r.data),
  listSearches: (exhibitionId) =>
    axios.get(`${BASE}/searches`, { params: { exhibition_id: exhibitionId } }).then((r) => r.data),
  getSearch: (id) => axios.get(`${BASE}/searches/${id}`).then((r) => r.data),
  cancelSearch: (id) => axios.post(`${BASE}/searches/${id}/cancel`).then((r) => r.data),
  qualifySearch: (id) => axios.post(`${BASE}/searches/${id}/qualify`).then((r) => r.data),

  patchSearchResult: (id, payload) =>
    axios.patch(`${BASE}/search-results/${id}`, payload).then((r) => r.data),
  rejectSearchResult: (id) =>
    axios.patch(`${BASE}/search-results/${id}/reject`).then((r) => r.data),
  archiveSearchResult: (id) =>
    axios.patch(`${BASE}/search-results/${id}/archive`).then((r) => r.data),
  convertSearchResult: (id) =>
    axios.post(`${BASE}/search-results/${id}/convert`).then((r) => r.data),
  saveProspect: (id) =>
    axios.post(`${BASE}/search-results/${id}/save-prospect`).then((r) => r.data),
  saveProspectsBulk: (searchId, opts = {}) =>
    axios.post(`${BASE}/searches/${searchId}/save-prospects`, opts).then((r) => r.data),

  // Contacts
  listContacts: (exhibitionId, params = {}) =>
    axios.get(`${BASE}/contacts`, { params: { exhibition_id: exhibitionId, ...params } }).then((r) => r.data),
  getContact: (id) => axios.get(`${BASE}/contacts/${id}`).then((r) => r.data),
  createContact: (payload) => axios.post(`${BASE}/contacts`, payload).then((r) => r.data),
  patchContact: (id, payload) => axios.patch(`${BASE}/contacts/${id}`, payload).then((r) => r.data),
  archiveContact: (id) => axios.patch(`${BASE}/contacts/${id}/archive`).then((r) => r.data),
  restoreContact: (id) => axios.patch(`${BASE}/contacts/${id}/restore`).then((r) => r.data),
  linkExhibition: (contactId, payload) =>
    axios.post(`${BASE}/contacts/${contactId}/link-exhibition`, payload).then((r) => r.data),

  patchLink: (linkId, payload) =>
    axios.patch(`${BASE}/exhibition-links/${linkId}`, payload).then((r) => r.data),

  // Threads
  listThreads: (exhibitionId, params = {}) =>
    axios.get(`${BASE}/threads`, { params: { exhibition_id: exhibitionId, ...params } }).then((r) => r.data),
  getThread: (id) => axios.get(`${BASE}/threads/${id}`).then((r) => r.data),
  patchThread: (id, payload) => axios.patch(`${BASE}/threads/${id}`, payload).then((r) => r.data),
  archiveThread: (id) => axios.patch(`${BASE}/threads/${id}/archive`).then((r) => r.data),
  pauseAgent: (id) => axios.post(`${BASE}/threads/${id}/pause-agent`).then((r) => r.data),
  resumeAgent: (id) => axios.post(`${BASE}/threads/${id}/resume-agent`).then((r) => r.data),
  takeoverAgent: (id) => axios.post(`${BASE}/threads/${id}/manual-takeover`).then((r) => r.data),
  generateOutreach: (id) =>
    axios.post(`${BASE}/threads/${id}/generate-outreach`).then((r) => r.data),
  generateReply: (id) =>
    axios.post(`${BASE}/threads/${id}/generate-reply`).then((r) => r.data),
  manualInbound: (id, payload) =>
    axios.post(`${BASE}/threads/${id}/manual-inbound`, payload).then((r) => r.data),
  getTicketUrl: (id) => axios.get(`${BASE}/threads/${id}/ticket-url`).then((r) => r.data),
  linkTicket: (id, ticketRequestId) =>
    axios.post(`${BASE}/threads/${id}/link-ticket`, { ticket_request_id: ticketRequestId }).then((r) => r.data),
  markFollowupDue: (id) =>
    axios.post(`${BASE}/threads/${id}/mark-followup-due`).then((r) => r.data),

  // Messages
  patchMessage: (id, payload) => axios.patch(`${BASE}/messages/${id}`, payload).then((r) => r.data),
  sendMessage: (id) => axios.post(`${BASE}/messages/${id}/send`).then((r) => r.data),

  // Follow-ups
  listFollowupsDue: (exhibitionId) =>
    axios.get(`${BASE}/followups-due`, { params: { exhibition_id: exhibitionId } }).then((r) => r.data),

  // Suppression
  listSuppression: () => axios.get(`${BASE}/suppression`).then((r) => r.data),
  addSuppression: (payload) => axios.post(`${BASE}/suppression`, payload).then((r) => r.data),
};

export const AUDIENCE_TYPES = [
  'artist', 'collector', 'curator', 'gallery', 'press', 'institution',
  'art_advisor', 'patron', 'museum', 'foundation', 'academic', 'sponsor',
  'brand_partner', 'hospitality_partner', 'influencer', 'tech_web3',
  'local_vip', 'other',
];

export const THREAD_STATUSES = [
  'draft', 'queued', 'sent', 'delivered', 'opened', 'clicked', 'replied',
  'interested', 'followup_1_due', 'followup_1_sent', 'followup_2_due',
  'followup_2_sent', 'ticket_requested', 'converted', 'not_interested',
  'paused', 'bounced', 'unsubscribed', 'failed', 'archived',
];

export const PRIORITIES = ['low', 'normal', 'high', 'vip'];

export const SEARCH_RESULT_STATUSES = ['new', 'reviewed', 'saved', 'rejected', 'converted', 'archived'];

export const DUPLICATE_STATUSES = [
  'new', 'exact_email', 'exact_social', 'exact_website', 'possible_duplicate',
  'existing_contact', 'already_invited', 'already_ticketed', 'suppressed',
];
